import { createSerializer } from 'nuqs'
import { parseAsUuid } from '@joyful/utils'
import { EncountersFiltersQueryParams } from '../hooks/useEncounterFilters'

export const EncounterTimelineSelectionQueryMap = {
  encounter_id: parseAsUuid,
}

export function getEncounterListTimelineHref({
  encounterId,
  orgSlug,
}: {
  encounterId: string
  orgSlug: string
}) {
  // Built per call: useEncounterFilters imports this module, so its exports are undefined at load time.
  const serializeEncounterListTimelineQuery = createSerializer({
    idsFilter: EncountersFiltersQueryParams.idsFilter,
    ...EncounterTimelineSelectionQueryMap,
  })
  return serializeEncounterListTimelineQuery(`/${orgSlug}/encounters`, {
    encounter_id: encounterId,
    idsFilter: [encounterId],
  })
}
